import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonDeleteButton, CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { AmountFormat, CheckAccessFunc, formatDateAndTimeMeth2 } from '../../../Components/CommonFunctions/CommonFunctions'
import { CurrencySymbol } from '../../../Utility/Constants'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { DateTime } from 'luxon';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker'


const active_status = [{ label: "All", value: "" }, { label: "Moved to PO", value: "approved" }, { label: "Pending", value: "pending" }, { label: "Cancelled", value: "rejected" }]

export default function StorePurhaseRequestList() {

    const filters = {
        fromDate: "",
        toDate: "",
        dateIndex: 0,
        vendorName: null,
        PrNumber: ""
    }
    const history = useHistory();
    const location = useLocation();
    const [departmentList, setDepartmentList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [departmentname, setDepartmentName] = useState('');
    const [departmentcode, setDepartmentCode] = useState('');
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [EditListID, setEditListID] = useState(null);
    const [DeleteIds, setDeleteIds] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [filterActiveStatus, setFilterActiveStatus] = useState({ label: "All", value: "" });
    const [filterData, setfilterData] = useState(filters);
    const [vendorList, setvendorList] = useState([]);
    const EditAccess = CheckAccessFunc("Store", "Purchase", "Purchase Request", null, "Tab")?.editAccess

    useEffect(() => {
        getPurchaseRequest()
        getVendorList()
        if (location.states?.success_message) {
            successMessage(location.states?.success_message)
            history.push({ states: { ...location?.states, success_message: "" } })
        }
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getPurchaseRequest = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_PURCHASE_REQUEST + `?from_date=${filterData.fromDate}&to_date=${filterData.toDate}` + `&vendor_id=${filterData?.vendorName?.id ? filterData?.vendorName?.id : ""}` + `&request_number=${filterData?.PrNumber}` + `&request_status=${filterActiveStatus?.value || ""}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setDepartmentList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getVendorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_VENDOR)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setvendorList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const onChangeHandler = (e, name) => {
        let value = e.target.value
        switch (name) {
            case 'departmentname':
                if (value === "" || value.length <= 50) {
                    setDepartmentName(value)
                }
                break
        }
    }

    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    value={val ? val : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }
    const tableView = () => {
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText />
                </Box>
            )
        }

        departmentList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'sno', headerName: 'S No', flex: 0.05,
            },
            {
                field: 'request_date', headerName: 'PR Date', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.request_date ? formatDateAndTimeMeth2(params?.row?.request_date) : '-'}</Box>)
            },
            {
                field: 'request_number', headerName: 'PR No', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.request_number ? params?.row?.request_number : '-'}</Box>)
            },
            {
                field: 'vendor_name', headerName: 'Vendor Name', flex: 0.2,
                renderCell: (params) => (params.row.vendor_name ? params.row.vendor_name?.length > 25 ?
                    <Tooltip placement="top" title={params.row.vendor_name}><Typography fontSize={'0.9vw'}>{params.row.vendor_name?.slice(0, 25) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.vendor_name}</Typography> : '-')

            },
            {
                field: 'gst_number', headerName: 'GST No', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.gst_number ? params?.row?.gst_number : '-'}</Box>)
            },
            {
                field: 'requested_items', headerName: 'No of Items', flex: 0.1,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.requested_items ? params?.row?.requested_items : '-'}</Box>)
            },
            {
                field: 'status', headerName: 'Action', flex: 0.1,
                renderCell: (params) => {
                    let purchase_status = params?.row?.request_status === "approved" ? "Moved to PO" : params?.row?.request_status === "rejected" ? "Cancelled" : params?.row?.request_status === "pending" ? "Pending" : "-"
                    let divColor = params?.row?.request_status === "approved" ? "#ECFFE9" : params?.row?.request_status === "rejected" ? "#FFE9E9" : params?.row?.request_status === "pending" ? "#FFEFD8" : null;
                    let txtColor = params?.row?.request_status === "approved" ? "#1E972A" : params?.row?.request_status === "rejected" ? "#B82121" : params?.row?.request_status === "pending" ? "#dc8400" : null;
                    return (
                        <Stack sx={{ paddingX: "0.4vw", paddingY: "0.2vw", borderRadius: "0.2vw", backgroundColor: divColor, border: `1px solid ${txtColor}`, width: '10vw', textAlign: 'center' }}>
                            <Typography sx={{ color: txtColor, fontSize: "0.9vw" }}>{purchase_status ? purchase_status : "-"}</Typography>
                        </Stack>
                    );
                }

            },
            {
                field: 'action', headerName: 'Action', flex: 0.15,
                renderCell: (params) => (
                    <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                        {EditAccess ? <Tooltip title={"View & Edit Request"} placement="top" arrow>
                            <IconButton disabled={params.row.request_status !== "pending"} emed_tid={'st_view_' + params?.id} className='eMed_usrconf_btn' onClick={() => {
                                history.push({ pathname: "/StorePurchase/PurchaseRequest/Add", states: params.row })
                            }}>
                                <img src={(params.row.request_status === "pending") ? ImagePaths.LabEditButton.default : ImagePaths.DisabledEdit.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                            </IconButton>
                        </Tooltip> : null}
                        {EditAccess ? <Tooltip title={"Move to PO"} placement="top" arrow>
                            <Button
                                disabled={params.row.request_status !== "pending"}
                                onClick={() => { requestStatusPost(params.row, "approved") }}
                                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                <img src={(params.row.request_status !== "pending") ? ImagePaths.TickDisable.default : ImagePaths.TickEnable.default} alt="Create Bill" style={{ width: '1.5vw', height: '1.5vw' }} />
                            </Button>
                        </Tooltip> : null}
                        {EditAccess ? <Tooltip title={"Cancel Request"} placement="top" arrow>
                            <Button
                                disabled={params.row.request_status !== "pending"}
                                onClick={() => { requestStatusPost(params.row, "rejected") }}
                                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                <img src={(params.row.request_status !== "pending") ? ImagePaths.RejectDisable.default : ImagePaths.RejectEnable.default} alt="Create Bill" style={{ width: '1.5vw', height: '1.5vw' }} />
                            </Button>
                        </Tooltip> : null}
                        <Tooltip title={"Print Request"} placement="top" arrow>
                            <Button
                                onClick={() => { GetPrint(params.row) }}
                                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                <img src={ImagePaths.PrintIcons.default} alt="print" style={{ width: '1.5vw', height: '1.5vw' }} />
                            </Button>
                        </Tooltip>
                    </Box>)

            },
        ]
        return (
            <Box sx={{ height: '70vh', marginTop: '.5vw' }}>
                <DataGrid
                    rows={departmentList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = () => {
        setDepartmentName('');
        setDepartmentCode('');
    }

    const requestStatusPost = (data, status) => {
        try {
            let payload_data = {
                request_id: data?.purchase_request_id ? data?.purchase_request_id : null,
                inward_id: data?.inward_id ? data?.inward_id : null,
                status: status
            }
            RestAPIService.updateWithOutId(payload_data, `${Serviceurls.STORE_PURCHASE_REQUEST}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getPurchaseRequest()
                        closeFilter();
                        clearFunction()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }
    const deleteVendor = () => {
        try {
            RestAPIService.delete(`${Serviceurls.STORE_DEPARTMENT}?ids=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getPurchaseRequest()
                        closeFilter();
                        clearFunction()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const FilterDate = (from, to, index) => {
        setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
    }

    const GetPrint = (Data = null) => {
        try {
            RestAPIService.getAllPrint(Serviceurls.STORE_PURCHASE_REQUEST + `?from_date=${filterData.fromDate}&to_date=${filterData.toDate}` + `&vendor_id=${filterData?.vendorName?.id ? filterData?.vendorName?.id : ""}` + `&request_number=${filterData?.PrNumber}` + `&request_status=${filterActiveStatus?.value || ""}&purchase_request_id=${Data?.purchase_request_id || ""}&export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={filterData.fromDate}
                            ToDate={filterData.toDate}
                            DateIndex={filterData.dateIndex}
                            SelectedDates={FilterDate.bind(this)} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={active_status}
                            getOptionLabel={(option) => option?.label}
                            value={filterActiveStatus}
                            onChange={(event, newValue) => {
                                setFilterActiveStatus(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Active Status'}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            value={filterData.vendorName}
                            options={vendorList}
                            getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.vendor_name}
                            onChange={(event, newValue) => {
                                setfilterData({ ...filterData, vendorName: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Select Vendor'}
                                />
                            )} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            size='small'
                            sx={{ width: '20dvw' }}
                            label={'PR Number'}
                            value={filterData.PrNumber}
                            onChange={(e) => {
                                setfilterData({ ...filterData, PrNumber: e.target.value })
                            }} />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            setFilterActiveStatus({ label: "All", value: "" })
                            setfilterData({
                                fromDate: "",
                                toDate: "",
                                dateIndex: 0,
                                vendorName: null,
                                PrNumber: ""
                            })
                        }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getPurchaseRequest();
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box sx={{ display: 'flex', justifyContent: "flex-end", marginRight: "1vw", alignItems: "center" }}>
                <Button size='small' disabled={!EditAccess} sx={{ textTransform: 'capitalize' }} variant='contained' onClick={() => { history.push({ pathname: "/StorePurchase/PurchaseRequest/Add" }) }}>Purchase Request</Button>
                <Tooltip title={'Filter'} placement="top">
                    <IconButton onClick={() => { setFilterOpen(true) }}>
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box component={'div'} sx={{ height: '70vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this Purchase Request ?`}
                    deleteAlertPopupClose={closeFilter.bind(this)}
                    removeData={deleteVendor.bind(this)}
                />
                : null}
        </Box>
    )
}
